import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import debounce from 'lodash.debounce';
import { Controller, useFormContext } from 'react-hook-form';
import useFetchClients from '../../../../hooks/clients/useFetchClients';
import { setClientsSearchAction } from '../../../../redux/actions/clientsActions';
import SearchableSelect from './../SearchableSelect';

const ClientSelect = ({ disabled }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { clients } = useFetchClients({ unpaged: true });
  const dispatch = useDispatch();
  const isMobileView = useSelector((state) => state.screen.isMobileView);

  const selectOptions = clients.map((client) => {
    return {
      label: `${client.lastName} ${client.firstName} ${client.phone}`.trim(),
      value: client,
    };
  });

  const handleInputChange = (newValue) => {
    debounced(newValue);
  };

  const debounced = debounce((newValue) => {
    dispatch(setClientsSearchAction(newValue));
  }, 300);

  return (
    <div>
      <label className="input-label">Клієнт</label>
      <Controller
        name="client"
        rules={{ required: "Це поле є обов'язковим" }}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SearchableSelect
            disabled={disabled}
            value={
              value && {
                label: `${value.lastName} ${value.firstName} ${value.phone}`.trim(),
                value: value,
              }
            }
            options={selectOptions}
            isMobileView={isMobileView}
            placeholder={'Виберіть клієнта'}
            handleInputChange={handleInputChange}
            onChange={(selectedValue) => {
              onChange(selectedValue);
            }}
          />
        )}
      />
      {errors['client'] && <span className="text-xs text-contrast1 mt-1">{errors['client'].message}</span>}
    </div>
  );
};
export default ClientSelect;
